import { memo, useMemo, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { WarningIcon } from 'foundations-assets';
import UISelect from 'UIComponents/input/UISelect';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { updateEngagementData } from 'conversations-calling-message/timeline-call-metadata/common/clients/updateEngagementData';
import { getCallDisposition, getCRMObjectId, getResult } from '../../call-message/operators/callMessageGetters';
import { logNetworkError } from 'calling-error-reporting/report/error';
import { useFetchCallDispositions } from '../hooks/useFetchCallDispositions';
import { getDefaultOptions } from '../utils/getDefaultOptions';
import { useFetchCallSettings } from '../hooks/useFetchCallSettings';
import { OUTGOING } from 'conversations-message-history/common-message-format/constants/messageDirections';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MutableCallDisposition = ({
  callDirection,
  callMessage,
  handleEngagementDataUpdated
}) => {
  const initialCallDisposition = getResult(getCallDisposition(callMessage));
  const [selectedDisposition, setSelectedDisposition] = useState(initialCallDisposition);
  const {
    dispositionsList,
    loading
  } = useFetchCallDispositions();
  const {
    callOutcomeRequired
  } = useFetchCallSettings();
  const renderCallOutcomeRequiredTooltip = useMemo(() => callOutcomeRequired && callDirection === OUTGOING && !selectedDisposition, [callDirection, callOutcomeRequired, selectedDisposition]);
  const engagementId = getCRMObjectId(callMessage);
  const handleSelectDisposition = event => {
    const option = event.target.value;
    const selectedDispositionId = option.value;
    const selectedDispositionText = option.text;
    if (selectedDispositionText !== selectedDisposition) {
      setSelectedDisposition(selectedDispositionText);
      const payload = {
        properties: [{
          name: 'hs_call_disposition',
          value: selectedDispositionId
        }]
      };
      updateEngagementData(engagementId, payload).then(() => {
        handleEngagementDataUpdated({
          engagementId
        });
      }).catch(networkError => {
        logNetworkError({
          error: new Error('Error updating call outcome'),
          networkError
        });
      });
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    paddingInlineEnd: "600",
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        typography: "detail-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.timeline-call-metadata.call-dispositions.label"
        })
      }),
      paddingBlockStart: "100",
      paddingBlockEnd: "400",
      children: /*#__PURE__*/_jsx(UISelect, {
        buttonUse: "link",
        "data-selenium-test": 'select-call-disposition-dropdown',
        isLoading: !dispositionsList && loading,
        menuWidth: "auto",
        onSelectedOptionChange: handleSelectDisposition,
        options: dispositionsList || getDefaultOptions(),
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.timeline-call-metadata.call-dispositions.placeholder"
        }),
        searchable: false,
        value: selectedDisposition
      })
    }), renderCallOutcomeRequiredTooltip && /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "900",
      paddingInlineStart: "100",
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.timeline-call-metadata.call-dispositions.required"
        }),
        children: /*#__PURE__*/_jsx(WarningIcon, {
          color: "do-not-use-candy-apple",
          size: "500"
        })
      })
    })]
  });
};
export default /*#__PURE__*/memo(MutableCallDisposition);